import { builderMobileApi } from '~/components/Builder/Mobile/Entities/BuilderMobileApi';
import { AllOutboundEvents } from '~/components/Builder/Mobile/builderMobileApi.types';

interface IEventEmitterControllerProps {
    isMobile: boolean;
}

export class EventEmitterController {
    isMobile: boolean;

    init({ isMobile }: IEventEmitterControllerProps) {
        this.isMobile = isMobile;
    }

    trigger(eventName: AllOutboundEvents, args) {
        if (this.isMobile) {
            builderMobileApi.triggerOutboundEvent(eventName, args);
        }
    }
}
